<template>
  <div>
    <div class="nav-con">
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div>sdfsfsfsfsdf</div>
        <div class="abs">sdfsdf</div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.nav-con {
  border: 1px solid red;
  position: relative;

  &>.abs{
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      border: 1px solid green;
      height: 2rem;
  }
}
</style>